export default __webpack_public_path__ + "static/media/file-folder_darkGray1.ad055578.svg";